import { Alert, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';
import { useAuthStore } from '@/store/authStore';
import { canAccessRouteByPermissions } from '@/config/routePermissions';

export default function CommsHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const perms = useAuthStore((s) => s.user)?.permissions || [];
  const cards = [
    { path: '/education/comms/templates', title: t('commTemplates'), description: t('commTemplatesIntro') },
    { path: '/education/comms/sends', title: t('commSends'), description: t('commSendsIntro') },
  ].filter((c) => canAccessRouteByPermissions(c.path, perms, false));

  return (
    <EducationPageChrome title={t('comms')} description={t('commsIntro')}>
      <Alert type="info" showIcon style={{ marginBottom: 16 }} message={t('commsOutboundHint')} />
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card hoverable onClick={() => navigate(card.path)}>
              <Typography.Title level={5}>{card.title}</Typography.Title>
              <Typography.Paragraph type="secondary">{card.description}</Typography.Paragraph>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
